/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Member_Subscribed_DescriptionInputs */

const en_newsletter_member_subscribed_description = /** @type {(inputs: Newsletter_Member_Subscribed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New issues land in your inbox automatically.`)
};

/**
* | output |
* | --- |
* | "New issues land in your inbox automatically." |
*
* @param {Newsletter_Member_Subscribed_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_member_subscribed_description = /** @type {((inputs?: Newsletter_Member_Subscribed_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Member_Subscribed_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_member_subscribed_description(inputs)
});